<template>
    <div class="videoBg">
        <div class="videoBox" id="videoBox" v-show="videoFlag"></div>
        <div class="loading" v-if="!videoFlag">
            <img src="@/assets/img/gif/loading.gif">
        </div>
        <div class="changeVideo" v-if="videoFlag">
            <p class="text">摄像头</p>
            <template v-for="item in this.smartPitchList" v-if="item.stream === $route.query.pitch">
                <p class="videoItem" v-for="(i,index) in item.cameras"
                   :class="(i.channel === videoItem.channel) ? 'check' : '' "
                @click="changeVideoFn(i)">{{ index + 1 }}</p>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "smartPitchDetail",
    data() {
        return {
            smartPitchList: [],
            smartPitchCamera: {},
            playUrl: '',

            myVideo: null,
            videoFlag: false,

            videoItem: {},
        }
    },
    mounted() {

        this.getList();

        this.myVideo ? this.myVideo.dispose() : '';
    },
    methods: {
        getList() {
            this.$server.getSmartPitchDevices()
                .then(res => {
                    console.log(res);
                    this.smartPitchList = res.data;
                })
            this.$server.getSmartPitchStreams()
                .then(res => {
                    console.log(res);
                    this.smartPitchCamera = res.data;
                    this.videoItem = JSON.parse(this.$route.query.video)
                    this.infoVideo(this.$route.query.pitch, this.videoItem)

                })
        },
        infoVideo(pitch, video) {
            console.log('点击播放');
            console.log(this.smartPitchCamera[pitch])
            console.log(video)
            let that = this;

            this.myVideo ? this.myVideo.dispose() : '';

            let videoItem = this.smartPitchCamera[pitch].channels[video.channel];

            this.playUrl = `http://${videoItem.properties.ip}:${videoItem.properties.server_port}/stream/${pitch}/channel/${video.channel}/hls/live/index.m3u8`

            // 创建video标签
            this.createVideo(this.playUrl);

            console.log(this.playUrl);

            setTimeout(() => {
                this.myVideo = this.$video(document.getElementById('smartPitch'), {

                    autoplay: true,

                    controls: true,

                    bigPlayButton: false,

                    textTrackDisplay: false,

                    posterImage: false,

                    errorDisplay: false,

                }, function () {

                    this.on('playing', function () {

                        if (!that.videoFlag) {
                            that.videoFlag = true;
                        }

                    })


                }).src({
                    src: this.playUrl,
                    type: 'application/x-mpegURL'
                })

            })
        },
        createVideo() {
            // console.log('创建标签')
            let box = document.getElementById('videoBox');
            // 获取 div 标签下的所有子节点
            var pObjs = box.childNodes;
            for (var i = pObjs.length - 1; i >= 0; i--) { // 一定要倒序，正序是删不干净的，可自行尝试
                box.removeChild(pObjs[i]);
            }


            let video = document.createElement('video');
            video.id = 'smartPitch';
            video.style.width = '100%';

            box.appendChild(video);

        },

        changeVideoFn(video) {
            this.videoFlag = false;
            this.videoItem = video;
            this.infoVideo(this.$route.query.pitch, video)
        }
    },
    beforeDestroy() {
        this.myVideo ? this.myVideo.dispose() : '';
    }
}
</script>

<style scoped lang="less">

.videoBg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 1000;
}

.videoBox {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    #smartPitch {
        width: 100%;
    }
}

.loading {
    font-size: 30px;
    color: rgba(255, 255, 255, .4);
    margin-top: 20vw;
}

::v-deep .vjs-loading-spinner, ::v-deep .vjs-control-bar, ::v-deep .vjs-modal-dialog {
    display: none !important;
}

.changeVideo {
    position: fixed;
    top: 30%;
    right: 0;
    z-index: 3000000;
    background: rgba(19, 20, 27, .8);
    border-radius: 15px 0 0 15px;
    padding-top: 1vw;
    padding-bottom: .5vw;
    .text {
        font-size: 26px;
        margin-bottom: 1vw;
        color: rgba(255, 255, 255, .9);
    }

    .videoItem {
        font-family: akrobatBold;
        background: rgba(19, 20, 27, 0.5);
        color: rgba(255, 255, 255, .4);
        border: 2px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        width: 3vw;
        height: 3vw;
        line-height: 3vw;
        margin-left: 1.5vw;
        margin-right: 1vw;
        font-size: 28px;
        margin-bottom: 1vw;

        &.check {
            background: rgba(54, 99, 225, 0.5);
            border: 2px solid #3663E1;
            color: #FFFFFF;
        }
    }
}
</style>